import React from 'react';
import BaseComponent from 'src/components/BaseComponent';
import AuthContainer from 'src/components/AuthContainer';

import { withRouter, lang, permissions, deviceIsMobile } from 'src/helpers';

import mainModel from 'src/model';

import model from './model';
import LANG_CONST from 'src/helpers/lang/const';
import SignupClinic from 'src/components/authPopup/SignupClinic';

const apiStateId = 'signupClinic';

class BasicStep extends BaseComponent {
  componentDidMount() {
    model.subscribe(this.subscription);
  }

  componentWillUnmount() {
    model.unsubscribe(this.subscription);
  }

  render() {
    const createState = model.getApiState(apiStateId);
    const { invalid } = createState;
    const searchParams = new URLSearchParams(this.props.router.location.search);
    const gid_token = searchParams.has('gid_token') ? searchParams.get('gid_token') : null;

    return (
      <AuthContainer enableHomeLeft={false} enableFooter={false}>
        <div className={'mc-page-auth-box'}>
          <div className={'mc-box-header'}>
            <h4 className='mc-box-title'>{lang.t(LANG_CONST.titles.signup)}</h4>
          </div>
          <SignupClinic
            gidToken={gid_token}
            setSignUpState={model.handleProfile}
            bigForm={!this.props.screenDetail?.isSmallScreen && !deviceIsMobile}
            handleSignupSubmit={(e, data) => {
              mainModel.checkConfirmCookiePolicy().then(
                (accept) =>
                  accept &&
                  model.signUpClinic(
                    data,
                    (valid) => {
                      if (valid) {
                        permissions.history = {
                          url: permissions.PAGES.PHONE_VERIFICATION_PAGE.path,
                          params: { isRedirect: true }
                        };
                      }
                    },
                    gid_token
                  )
              );
            }}
            loading={model.getApiState(apiStateId).loading}
            invalid={invalid}
            onClickLogin={(e) => {
              e.preventDefault();
              this.navigate(permissions.PAGES.LOGIN_PAGE.path);
            }}
            router={this.props.router}
          />
        </div>
      </AuthContainer>
    );
  }
}

export default withRouter(BasicStep);
